import type { ApiError } from '@/core/types/api.types'

export function logFallback(namespace: string, error: unknown, context?: string): void {
  const message = getErrorMessage(error)
  const suffix = context ? ` — ${context}` : ''
  // eslint-disable-next-line no-console
  console.warn(`[${namespace}] ${message}${suffix}`, error)
}

export function getErrorMessage(error: unknown): string {
  if (error instanceof Error) return error.message
  if (typeof error === 'string') return error
  if (error && typeof error === 'object' && 'message' in error) {
    return String((error as { message: unknown }).message)
  }
  return 'Error desconocido'
}

export function isApiError(error: unknown): error is ApiError {
  return (
    error !== null &&
    typeof error === 'object' &&
    'status' in error &&
    typeof (error as ApiError).status === 'number'
  )
}

export function getResponseErrorMessage(response: unknown, fallback: string): string {
  if (response && typeof response === 'object') {
    const record = response as Record<string, unknown>

    if (typeof record.message === 'string' && record.message) {
      return record.message
    }

    if (typeof record.data === 'string' && record.data) {
      return record.data
    }

    const dteResponse = record.dte_response
    if (dteResponse && typeof dteResponse === 'object') {
      const dteMsg = (dteResponse as Record<string, unknown>).msg
      if (typeof dteMsg === 'string' && dteMsg) {
        return dteMsg
      }
    }
  }

  return fallback
}

export function getApiErrorMessage(error: unknown, fallback?: string): string {
  if (isApiError(error)) {
    switch (error.status) {
      case 400:
        return error.message || 'Error de validación. Verifique los datos ingresados.'
      case 401:
        return 'No autorizado. Por favor inicie sesión nuevamente.'
      case 403:
        return 'No tiene permisos para realizar esta operación.'
      case 404:
        return error.message || 'El recurso solicitado no fue encontrado.'
      case 500:
        return 'Error interno del servidor. Intente nuevamente más tarde.'
      default:
        return error.message || fallback || 'Ocurrió un error inesperado.'
    }
  }
  return getErrorMessage(error) || fallback || 'Error desconocido'
}
